import React, { useEffect, useMemo, useState } from 'react';
import classNames from 'classnames';
import awardPrizeService from 'lib/services/awardPrizeService';
import { useAwardPrizeStore } from 'lib/store/awardPrize';
import { showModal } from 'lib/components/Modal';
import { ORDER_GOODS_TYPE, ORDER_STATE } from 'lib/constants/order';
import { fetchOrderPackage, fetchWUJIActivity } from 'lib/apis';
import { useUserOrderStore } from 'lib/store/userOrderStore';
import { captchaModalInit } from 'lib/container/SMSCaptchaModal';
import { generatorOrderUrl, getGiftBtnType, getPackageName, getPureText } from 'lib/utils/util';
import channelService from 'lib/services/channelService';
import { showOrderMobileInput } from 'lib/components/MobileInput';
import { OPERATOR_TYPE } from 'lib/constants/operator';
import { AWARD_TYPES } from 'lib/constants/award';
import event from 'lib/utils/event';
import { EVENT } from 'lib/utils/event/constant';
import { addReportPublicParams, report } from 'lib/utils/dataReport';
import { ATTA_REPORT } from 'lib/constants/atta';
import { currentUrlParams } from 'lib/utils/url';
import { useMobileStore } from 'lib/store/mobileStore';
import { useGlobalStore } from 'lib/store';
import './styles.scss';

export default function RightReceiveButton({ data, commonStyle }) {
  const { cmccActivityId, unionActivityId, telcomActivityId, receivedBtnImg, tobeReceiveBtnImg } = data;
  const userOrderInfo = useUserOrderStore((state) => state.userOrderInfo);
  const receivedPrizeList = useAwardPrizeStore((state) => state.receivedPrizeList);
  const [actId, setActId] = useState(0);
  const isReceived = useMemo(() => receivedPrizeList.indexOf(+actId) !== -1, [receivedPrizeList, actId]);
  const mobileInput = useMobileStore((state) => state.inputMobile);
  const globalStore = useGlobalStore((state) => state);

  useEffect(() => {
    if (!userOrderInfo?.operatorType || userOrderInfo?.pType !== ORDER_GOODS_TYPE.BENEFIT) return;
    let actId;
    switch (userOrderInfo?.operatorType) {
      case OPERATOR_TYPE.CMCC: {
        actId = cmccActivityId;
        break;
      }
      case OPERATOR_TYPE.UNICOM: {
        actId = unionActivityId;
        break;
      }
      case OPERATOR_TYPE.TELCOM: {
        actId = telcomActivityId;
        break;
      }
    }
    awardPrizeService.registerGiftData(+actId, AWARD_TYPES.RIGHTS);
    setActId(+actId);
    // 更新完活动ID后，触发领奖状态查询
    event.emit(EVENT.UPDATE_PRIZE_STATUS);
  }, [userOrderInfo]);

  // 触发领奖
  const receiveGift = async () => {
    if (isReceived) {
      // 提示当前礼包已领取
      return;
    }
    addReportPublicParams({
      orderTriggerType: getGiftBtnType(AWARD_TYPES.RIGHTS),
    });
    report(ATTA_REPORT.RECEIVE_PRIZE.LOTTERY);
    switch (userOrderInfo.orderState) {
      case ORDER_STATE.CANCELING:
      case ORDER_STATE.CANCEL_SUCCESS:
      case ORDER_STATE.ORDER_SUCCESS: {
        return awardPrizeService.receiveGift(+actId);
      }

      case ORDER_STATE.PLACE_ORDER: {
        // 如果用户主动修改页面输入框上的手机号，则需要再次确认并走下单流程
        if (mobileInput !== userOrderInfo?.orderMobile) {
          showOrderMobileInput(AWARD_TYPES.RIGHTS);
          return;
        }
        if (userOrderInfo?.operatorType === OPERATOR_TYPE.UNICOM) {
          const subStatTag = currentUrlParams.getCurrentParams('SubStatTag') || channelService.channelTag;
          const shareToken = currentUrlParams.getCurrentParams('shareToken');
          const redirectURL = generatorOrderUrl(userOrderInfo);
          const res = await fetchOrderPackage({
            packageId: userOrderInfo?.pId || '',
            channelCode: channelService.channelCode,
            mobile: userOrderInfo?.orderMobile || '',
            subStatTag,
            redirectURL,
            shareToken,
          });
          if (res?.code !== 0) return;
          const { url, orderMethod } = res?.data || {};

          if (url && orderMethod === 1) {
            window.location.href = url;
            return;
          }
          return;
        }
        const res = await fetchWUJIActivity();
        if (res?.code !== 0) return;
        const activityConfigList = res?.data || [];
        const {
          price_desc: packagePrice,
          is_promotional: isPromotional,
          package_name: packageName,
          subscribe_hint: orderTips,
        } = activityConfigList.find((c) => c.p_id === userOrderInfo.pId) || {};
        const { smsModalTheme } = globalStore;
        showModal(
          captchaModalInit({
            channelCode: channelService.channelCode,
            mobile: userOrderInfo.orderMobile,
            operatorType: userOrderInfo.operatorType,
            packageId: userOrderInfo.pId,
            priceDesc: packagePrice,
            packageName: getPackageName(userOrderInfo.operatorType, isPromotional, packageName),
            orderTips: getPureText(orderTips),
            smsModalTheme,
            isPromotional,
          }),
          {
            onBottom: !!smsModalTheme,
          },
        );
        return;
      }

      default: {
        showOrderMobileInput(AWARD_TYPES.RIGHTS);
        return;
      }
    }
  };

  return (
    <div
      className={classNames('right-receive-btn', {
        disabled: isReceived,
      })}
      id={`gift-${actId}`}
      style={commonStyle}
      onClick={receiveGift}
      data-gift-btn-type="benefit"
      data-is-received={!!isReceived}
      data-test-id="receive-benefit"
    >
      <img className="btn-img" src={isReceived ? receivedBtnImg : tobeReceiveBtnImg} />
    </div>
  );
}
